import { cn } from "@gigpro/ui/tailwind/cn";
import { Link, useMatchRoute } from "@tanstack/react-router";
import { useNavLinkProps } from "layouts/BaseLayout/utils";
import { useShiftsNavItems } from "../useShiftsNavItems";

export function ShiftsBottomNavigation() {
  const navItems = useShiftsNavItems().bottomBar;
  const matchRoute = useMatchRoute();
  const navLinkProps = useNavLinkProps();

  if (navItems.length === 0) return null;
  return (
    <div
      style={{ viewTransitionName: "bottom-navigation" }}
      className="fixed bottom-0 z-10 grid h-nav-bottom w-full auto-cols-[1fr] grid-flow-col items-center justify-center bg-black"
    >
      {navItems.map(({ title, path, keepParams, search, external, icon }) => {
        const linkProps = navLinkProps({ path, keepParams, search, external });
        const isActive = !!matchRoute({ to: linkProps.to, fuzzy: true });

        return (
          <Link
            key={title}
            {...linkProps}
            target={external ? "_blank" : undefined}
            className={cn(
              "flex flex-col items-center text-white *:first:h-4 hover:scale-110 hover:text-brand-hover [&>*:first-child]:w-4",
              isActive && "font-semibold text-brand-hover",
            )}
          >
            {icon}
            <p className="mt-0.5 text-small">{title}</p>
          </Link>
        );
      })}
    </div>
  );
}
